(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Copyright', Copyright);

    Copyright.$inject = ['$resource'];

    function Copyright ($resource) {
        var resourceUrl =  'api/copyrights/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
